/* ============================================================
 * Piezas compartidas del Hub.
 * ============================================================ */

import React from 'react';
import { useCtx } from '../estado.jsx';

/**
 * Indicador numérico de cabecera.
 *
 * El original recibía HTML en texto y lo inyectaba con
 * dangerouslySetInnerHTML: `val={ocup+'<small>%</small>'}`. Con datos fijos
 * en el propio frontend era inofensivo, pero ahora estos valores vienen del
 * backend, y uno de ellos puede acabar conteniendo el nombre que escribió un
 * cliente. Inyectar eso como HTML es un XSS de manual, así que el sufijo y
 * el pie pasan a ser props aparte y React los escapa.
 */
export function Kpi({ label, val, sufijo, foot }) {
  return (
    <div className="kpi">
      <div className="k-label">{label}</div>
      <div className="k-val">{val}{sufijo ? <small>{sufijo}</small> : null}</div>
      {foot ? <div className="k-foot">{foot}</div> : null}
    </div>
  );
}

export function Wave({ cls }) {
  return (
    <svg className={cls} viewBox="0 0 56 12">
      <path d="M0 6 Q 7 1,14 6 T 28 6 T 42 6 T 56 6" />
    </svg>
  );
}

/** Espera de una lectura. Ocupa sitio para que la página no dé saltos. */
export function Cargando({ que = 'los datos' }) {
  return <div className="empty-line">Cargando {que}…</div>;
}

/**
 * Fallo de una lectura. Siempre con salida: un error sin forma de reintentar
 * obliga a recargar la página entera para volver a intentarlo.
 */
export function ErrorCarga({ error, reintentar }) {
  return (
    <div className="card" style={{ padding: '20px', textAlign: 'center' }}>
      <div className="inline-err show" style={{ marginBottom: '12px' }}>
        {error?.message || 'No se han podido cargar los datos.'}
      </div>
      {reintentar ? <button className="btn" onClick={reintentar}>Reintentar</button> : null}
    </div>
  );
}

/**
 * Envuelve una lectura y pinta el estado que toque. Evita repetir el
 * cargando/error/datos en cada vista y, sobre todo, evita olvidarlo.
 */
export function Recurso({ estado, que, children }) {
  const { refrescar } = useCtx();
  if (estado.cargando) return <Cargando que={que} />;
  if (estado.error) return <ErrorCarga error={estado.error} reintentar={refrescar} />;
  return children(estado.datos);
}

export function Modal({ children }) {
  const { closeModal } = useCtx();
  return (
    <div
      className="hub-modal-bg show"
      onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
    >
      <div className="hub-modal">{children}</div>
    </div>
  );
}

export function SedeTabs({ id, active }) {
  const { session, go } = useCtx();
  if (session.rol !== 'aleph') return null;
  const tabs = [['sede', 'Tablero'], ['editsede', 'Editar datos']];
  return (
    <div className="tabbar">
      {tabs.map((t) => (
        <button key={t[0]} className={'tab' + (t[0] === active ? ' on' : '')}
                onClick={() => go(t[0], id)}>{t[1]}</button>
      ))}
    </div>
  );
}
